export default __webpack_public_path__ + "assets/logos/52ebf0431dab3c3315ce0860244fe48a.png";